import React from 'react';
import * as Styles from './IconShapedStars.styles';

const IconShapedStars = () => (
  <Styles.Svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="IconShapedStars"
  >
    <g clipPath="url(#clip0_3287_7986)">
      <path
        d="M3.7513 18.3327V14.166M3.7513 5.83268V1.66602M1.66797 3.74935H5.83464M1.66797 16.2493H5.83464M10.8346 2.49935L9.38947 6.25673C9.15447 6.86776 9.03697 7.17327 8.85422 7.43026C8.6923 7.65802 8.4933 7.85701 8.26554 8.01896C8.00856 8.20169 7.70304 8.31919 7.09202 8.55418L3.33464 9.99935L7.09202 11.4445C7.70304 11.6795 8.00856 11.797 8.26554 11.9798C8.4933 12.1417 8.6923 12.3407 8.85422 12.5684C9.03697 12.8254 9.15447 13.1309 9.38947 13.7419L10.8346 17.4993L12.2798 13.7419C12.5148 13.1309 12.6323 12.8254 12.8151 12.5684C12.977 12.3407 13.176 12.1417 13.4037 11.9798C13.6607 11.797 13.9662 11.6795 14.5772 11.4445L18.3346 9.99935L14.5772 8.55418C13.9662 8.31919 13.6607 8.20168 13.4037 8.01896C13.176 7.85701 12.977 7.65802 12.8151 7.43026C12.6323 7.17327 12.5148 6.86776 12.2798 6.25673L10.8346 2.49935Z"
        stroke="#0070D1"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3287_7986">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </Styles.Svg>

);

export default IconShapedStars;
